import {
  ButtonPure,
  Colors,
  Modal,
  ModalHr,
  Typography
} from '@giantleap/components-library'
import * as moment from 'moment'
import * as React from 'react'
import { getTimeForNewAssessment } from 'services/historyMode/historyMode'
import styles from './style.module.scss'
import { IProps } from './types'

function HistoryModal({
  onSelectClick,
  active,
  setActive,
  datesArr,
  activeDate,
  currentAssessment
}: IProps) {
  const sortDatesArr = datesArr.sort(
    (prevDate, nextDate) => nextDate - prevDate
  )

  return (
    <Modal active={active} setActive={setActive} baseClassName={styles.wrap}>
      <Typography type="title" size="big">
        Evaluation History
      </Typography>
      <Typography type="text">
        <span style={{ color: Colors.paleDarkBlue }}>
          Next evaluation in: {getTimeForNewAssessment(activeDate)}
        </span>
      </Typography>
      <ModalHr />
      {sortDatesArr.map((currentDate, key) => (
        <ButtonPure
          key={key}
          onClick={() => onSelectClick(currentDate)}
          alignX="left"
          type="max"
          // disabled={currentDate === activeDate}
        >
          <Typography type="headline" size="small">
            <span
              style={{
                color:
                  currentDate === Number(currentAssessment)
                    ? Colors.purpleAccent
                    : ''
              }}
            >
              {moment.unix(currentDate).format('MMMM YYYY')}
            </span>
            {currentDate === activeDate ? (
              <span style={{ color: Colors.unselected }}> (current)</span>
            ) : (
              ''
            )}
          </Typography>
        </ButtonPure>
      ))}
    </Modal>
  )
}

export default HistoryModal



// WEBPACK FOOTER //
// ./src/components/HistoryModal/index.tsx